import React, { createContext, useContext, useState } from 'react';
const defaultGaps = {
    mobileGap: undefined,
    tabletGap: undefined,
    desktopGap: undefined
};
const GridContext = createContext(Object.assign(Object.assign({}, defaultGaps), { setGaps: undefined }));
GridContext.displayName = 'GridContext';
const GridProvider = ({ children, gaps: gapsProp = defaultGaps }) => {
    const [gaps, setGaps] = useState(gapsProp);
    const { mobileGap, tabletGap, desktopGap } = gaps;
    return (React.createElement(GridContext.Provider, { value: {
            mobileGap,
            tabletGap,
            desktopGap,
            setGaps
        } }, children));
};
export const useGrid = () => {
    return useContext(GridContext);
};
export default GridProvider;
